import AppLink from '../../../../../routing/helpers/AppLink';
import Translator from '../../../../components/helpers/Translator';

export default function SettingsTabs({ moduleBridgeHex, activeTab }) {
  return (
    <div className="nav nav-tabs">
      <AppLink
        className={`nav-item nav-link ${
          activeTab === 'resourceTemplates' ? 'active' : ''
        }`}
        path="user_module_resourceManager_settings_resourceTemplate_list"
        params={{ moduleBridgeHex }}
      >
        <Translator file="module-resourceManager" name="resource.templates" />
      </AppLink>
      <AppLink
        className={`nav-item nav-link ${
          activeTab === 'internalObligations' ? 'active' : ''
        }`}
        path="user_module_resourceManager_settings_internalObligations"
        params={{
          moduleBridgeHex,
        }}
      >
        <Translator file="module-resourceManager" name="resource.obligations" />
      </AppLink>
    </div>
  );
}
